import { Checkbox, DatePicker, FormCard, FormItem } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { Divider } from 'antd'
import type dayjs from 'dayjs'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { getRequiredRule } from '../utils'

type ReoccurenceStartDateProps = {
  hasEndDate?: boolean
  minDate?: dayjs.Dayjs
  maxDate?: dayjs.Dayjs
}

const ReoccurenceStartDate: FC<ReoccurenceStartDateProps> = ({
  hasEndDate,
  minDate,
  maxDate
}) => {
  const { t } = useTranslation()

  return (
    <FormCard level={2} title={t('START_END_DATE')}>
      <FormItem
        name="patternStart"
        label={<Text>{t('START_DATE')}</Text>}
        rules={[getRequiredRule(t('START_DATE'))]}
      >
        <DatePicker maxDate={maxDate} />
      </FormItem>
      <StyledDivider />
      <FormItem name="hasPatternEndDate" valuePropName="checked">
        <Checkbox>
          <Text>{t('HAS_END_DATE')}</Text>
        </Checkbox>
      </FormItem>
      {hasEndDate && (
        <FormItem
          name="patternEnd"
          label={<Text>{t('END_DATE')}</Text>}
          rules={[getRequiredRule(t('END_DATE'))]}
        >
          <DatePicker minDate={minDate as dayjs.Dayjs} />
        </FormItem>
      )}
    </FormCard>
  )
}

const StyledDivider = styled(Divider)`
  padding-top: 5px;
  padding-bottom: 5px;
  margin: 0px;
`

export default ReoccurenceStartDate
